import UserSession from '@javascripts/utils/user_session';
import localStorageAdapter from '@javascripts/adapters/localstorage_adapter';
import { PlayerEnvironment } from "./player_environment";
import { PlayerAhoyEvent } from "./player_ahoy_event";

export default class PlayerContinueWatching {
  constructor(data, tech) {
    this._videoIsEnded = false;
    this._data = data;
    this._tech = tech;
    this._storageName = 'continue_watching';
    this._storageSize = 20;
    this._isError = false;
    this._minWatchDuration = 30;
  }

  data() {
    return this._data;
  }

  videoIsEnded() {
    return this._videoIsEnded;
  }

  videoId() {
    return this.data().videoId();
  }

  tech() {
    return this._tech;
  }

  storageName() {
    return this._storageName;
  }

  storageSize() {
    return this._storageSize;
  }

  init() {
    this.continueIncompleteVideo();
    this.bindWindowUnload();
    this.bindVideoPlay();
    this.bindVideoEnded();
    this.clearData();
  }

  continueIncompleteVideo() {
    const videoInStorage = this.getCurrentVideoFromStorage();

    if (videoInStorage) {
      let timeShifted = false;

      let interval = setInterval(()=> {
        if (!this.tech().duration() || timeShifted) return;
        if (Math.floor(this.tech().currentTime()) == Math.floor(videoInStorage.time)) timeShifted = true;

        this.tech().currentTime(videoInStorage.time);
        PlayerAhoyEvent.sendContinueWatch(this.videoId());
        clearInterval(interval);
      }, 50);
    }
  }

  bindWindowUnload() {
    const eventName = PlayerEnvironment.browserName() === 'Mobile Safari' ? 'pagehide' : 'beforeunload';
    window.addEventListener(eventName, this.onbeforeunload.bind(this)());
  }

  onbeforeunload() {
    return this.beforeunloadHandler.bind(this);
  }

  createNewData(data) {
    const avodData = data.filter( datum => { return datum.isPremier != true } );
    const svodData = data.filter( datum => { return datum.isPremier == true } );
    if (this.data().isPremier()) {
      this.arrangeData(svodData);
    } else {
      this.arrangeData(avodData);
    }
    return svodData.concat(avodData);
  }

  arrangeData(data) {
    this.sortVideoData(data);
    let filmId = null;
    if (this.data().filmId() > 0) {
      filmId = this.data().filmId();
    }

    const currentWatchDuration = Math.floor(this.tech().currentTime());

    if (currentWatchDuration < this._minWatchDuration) {
      return data;
    }

    data.unshift({
      id: this.videoId(),
      time: currentWatchDuration,
      isPremier: this.data().isPremier(),
      timestamp: window.Date.now(),
      filmId: filmId
    });
    if (data.length > this.storageSize()) {
      data.pop();
    }
    return data;
  }

  sortVideoData(data) {
    data.sort((a, b) => {
      if (!a.timestamp && !b.timestamp) {
        return 0;
      } else if(!a.timestamp) {
        return 1;
      } else if(!b.timestamp) {
        return -1;
      } else {
        return b.timestamp - a.timestamp;
      }
    });
  }

  beforeunloadHandler() {
    if (this.videoIsEnded() && UserSession.isLoggedIn()) { return; }

    const oldData = this.getDataVideos();
    const newData = this.createNewData(oldData)
    this.sortVideoData(newData);
    this.saveIncompleteVideo(newData);
  }

  bindVideoPlay() {
    this.tech().on('play', () => {
      this._videoIsEnded = false;
    });
  }

  bindVideoEnded() {
    this.tech().on('vp-ended', () => {
      this._videoIsEnded = true;
      this.setVideoAsCompleted();
    });
  }

  saveIncompleteVideo(data) {
    localStorageAdapter().setItem(this.storageName(), JSON.stringify(data));
  }

  getIncompleteVideos() {
    const data = localStorageAdapter().getItem(this.storageName());
    return data !== null? JSON.parse(data) : [];
  }

  getCurrentVideoFromStorage() {
    return this.getIncompleteVideos().find(video => {
      return video.id === this.videoId();
    });
  }

  getDataVideos() {
    if (UserSession.isLoggedIn()) {
      return this.getDataWithoutCurrentVideo()
    }

    return this.getIncompleteVideos()
  }

  setVideoAsCompleted() {
    const newData = this.getDataVideos();
    this.saveIncompleteVideo(newData);
  }

  getDataWithoutCurrentVideo() {
    return this.getIncompleteVideos().filter(video => {
      return video.id !== this.videoId();
    });
  }

  clearData() {
    if (UserSession.isLoggedIn()) {
      return;
    } else {
      localStorageAdapter().removeItem(this._storageName);
    }
  }
}
